
import { combineReducers } from 'redux'
// import enthusiasm from './enthusiasm';
import { transition } from './transition';

export default combineReducers({
  // enthusiasm,
  // transition
});


// WEBPACK FOOTER //
// ./src/reducers/index.tsx